import { useContext } from 'react';
import { useRouter } from 'next/router';
import GoBack from '../../components/GoBack/GoBack';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import { LanguageContext } from '../contexts/Language.context';
import { LoginContext } from '../contexts/Login.context';
import { ThemeContext } from '../contexts/Theme.context';
import useLongPress from '../utils/useLongPress';
import useCachedLogo from '../utils/useCachedLogo';
import styles from './PageHeader.style';

export default function PageHeader({
  backButton = false,
  headerLeftExtra = null,
  showLanguageSelector = true,
  showLogoutButton = true,
  onLongPress = () => {},
  showShareButton = false,
}) {
  const router = useRouter();
  const { state: theme } = useContext(ThemeContext);
  const { actions: loginActions } = useContext(LoginContext);
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const isTravelAgentUser = localStorage.getItem('kiosk-user-type') === 'travel_agent';
  const isBookingSelectorRoute = router.route?.includes('bookingSelector');
  const canShowLogoutButton =
    showLogoutButton && showLanguageSelector && isTravelAgentUser && isBookingSelectorRoute;

  const longPressEvent = useLongPress(onLongPress);
  const logoSrc = useCachedLogo(theme.logo);

  const handleLogout = () => {
    loginActions.logout();
    sessionStorage.clear();
    sessionStorage.setItem('logged-out', 'true');
    window.location.replace('/login');
  };

  return (
    <div className={'header-content'}>
      <div className={'back-button-container'}>
        <div className={'back-button-group'}>
          {backButton ? <GoBack /> : null}
          {headerLeftExtra}
        </div>
      </div>
      {!theme.isIframe || !theme.canUseIframe ? (
        <>
          <div className={'image-container'}>
            {logoSrc && (
              <img
                className={'img-header'}
                src={logoSrc}
                alt="Civitfun header logo"
                {...longPressEvent}
                onError={(e) => {
                  e.currentTarget.style.display = 'none'; // Oculta el <img> si no carga
                }}
              ></img>
            )}
          </div>
          <div className={'language-container'}>
            {showLanguageSelector ? (
              <div className={'language-actions'}>
                <LanguageSelector />
                {canShowLogoutButton ? (
                  <button className={'logout-button'} onClick={handleLogout}>
                    {translate('kiosk.language.logout.button') || 'Log out'}
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>
        </>
      ) : null}

      <style jsx>{styles}</style>
    </div>
  );
}
